module.exports = __webpack_public_path__ + "media/images/emblems/Bueetigen-coat_of_arms-3a20b978ab96f7ee8b2fa85f97fa1526.svg";